import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function LevelUpCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("levelUpCard.title")}</h1>
      <p>{t("levelUpCard.intro")}</p>

      <CodeBlock title="levelUpImage()">{`import { levelUpImage } from "kira-arts";

const buffer = await levelUpImage(userId, newLevel, {
  guildId,
  useRoleColor: true,
  currentXp: 120,
  requiredXp: 400,
});`}</CodeBlock>

      <h2>{t("levelUpCard.optionsTitle")}</h2>
      <CodeBlock title="LevelUpOptions">{`message?: string;
currentXp?: number;
requiredXp?: number;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
customBackground?: string;
backgroundTint?: boolean;
accentColor?: string;
barColor?: ColorInput;
barBackgroundColor?: string;
levelColor?: string;
usernameColor?: string;
messageColor?: string;
showBadges?: boolean;
guildId?: string;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="levelUpCard.note"
          components={[<code key="0" />, <code key="1" />, <code key="2" />, <code key="3" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="levelUpCard.tintNote"
          components={[<code key="0" />]}
        />
      </p>
    </article>
  );
}
